$(document).on('turbolinks:load', function(){
    $("div.investment-item").click(function(){
        var bar = $(this).find(".accordion-collapse").find('div.progress-bar');
        var width = ((parseInt(bar[0].ariaValueNow)/parseInt(bar[0].ariaValueMax))*100) + "%";
        bar.css("width", width);
    });

    $("button.details").click(function(){
        var isActive = $(this).hasClass('active');
        if(!isActive){
            $("button.schedule").removeClass("active");
            $("button.schedule").removeClass("btn-active");
            $("button.schedule").addClass("btn-not-active");

            $("button.details").removeClass("btn-not-active");
            $("button.details").addClass("active");
            $("button.details").addClass("btn-active");


            $("div.payout-schedule").hide();
            $("div.investment-details").show();
        }
    });
    $("button.schedule").click(function(){
        var isActive = $(this).hasClass('active');
        if(!isActive){
            $("button.details").removeClass("active");
            $("button.details").removeClass("btn-active");
            $("button.details").addClass("btn-not-active");


            $("button.schedule").removeClass("btn-not-active");
            $("button.schedule").addClass("active");
            $("button.schedule").addClass("btn-active");

            $("div.investment-details").hide();
            $("div.payout-schedule").show();
        }
    });
});